import { httpClient } from "@/api/httpClient";

export function login(data) {
  return httpClient.post("/auth/signin", data);
}

export function register(data) {
  return httpClient.post("/auth/signup", data);
}

export function sendResetPasswordCode(data) {
  return httpClient.post("/auth/send-reset-password", data);
}

export function validateResetPasswordCode(data) {
  return httpClient.post("/auth/confirmation-email-code", data);
}

export function resetPassword(data) {
  return httpClient.post("/auth/reset-password", data);
}

export function fetchProfile() {
  return httpClient.get("/auth/profile");
}

export function changeEmail(data) {
  return httpClient.patch("/auth/profile/email", data);
}

export function changePassword(data) {
  return httpClient.patch("/auth/profile/password", data);
}

export function updateProfile(data) {
  return httpClient.patch("/auth/profile", data);
}

export function refresh(data) {
  return httpClient.post("/auth/refresh-tokens", data);
}
